import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { mask } from 'remask';

export function InputMask({
  control,
  name,
  pattern,
  controllerProps = {},
  isDisplay = false,
  ...rest
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TextField
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          {...field}
          {...rest}
          onBlur={(event) => {
            field?.onBlur?.(event);
            rest?.onBlur?.(event);
          }}
          value={isDisplay ? field?.value : mask(field?.value ?? '', pattern)}
        />
      )}
      {...controllerProps}
    />
  );
}

export default InputMask;
